module.exports = __webpack_public_path__ + "assets/images_base/business-times-logo.svg?v=324ab50e";